var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrass({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.272,
    height: 70,
    viewBox: "0 0 66.272 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grass",
    transform: "translate(-6 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1875",
    "data-name": "Path 1875",
    d: "M20,71.623C20,40.338,33.266,14.4,36.436,9c-1.556,5.111-5.479,14.741-5.479,62.675Z",
    transform: "translate(11.841 3.305)",
    fill: "#388e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1876",
    "data-name": "Path 1876",
    d: "M24,69.393C24,44.365,44.021,15.668,49.567,11c-3.075,4.277-14.61,22.446-14.61,58.485Z",
    transform: "translate(15.4 5.515)",
    fill: "#388e3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1877",
    "data-name": "Path 1877",
    d: "M24.784,66.134C24.784,35.088,14.5,18.888,12,15c3.223,3.329,23.741,29.249,23.741,51.134Z",
    transform: "translate(5.095 8.82)",
    fill: "#388e3c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_742",
    "data-name": "Group 742",
    transform: "translate(6 26.915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1878",
    "data-name": "Path 1878",
    d: "M48.341,65.04c0-25.2,20.651-45.529,23.932-48.04-2.634,3.172-12.886,20.325-12.886,48.04Zm-27.613,0C20.727,37.262,8.84,20.091,6,17c3.455,2.4,25.773,23.551,25.773,48.04Z",
    transform: "translate(-6 -17)",
    fill: "#8bc34a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_743",
    "data-name": "Group 743",
    transform: "translate(13.305 5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1879",
    "data-name": "Path 1879",
    d: "M27.218,38.116c.679,2.651,1.22,5.329,1.675,8.019,4.635,8.906,8.5,19.236,8.5,28.8l3.652-.031a137.862,137.862,0,0,0-2.769-19.664,111.641,111.641,0,0,0-5.869-18.9,91.338,91.338,0,0,0-9.323-17.22A62.177,62.177,0,0,0,10,5,61.109,61.109,0,0,1,20.736,20.55,87.4,87.4,0,0,1,27.218,38.116ZM30.09,74.954c0,.015,0,.031,0,.044l5.479-.044Z",
    transform: "translate(-10 -5)",
    fill: "#4caf50"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrass);
export default __webpack_public_path__ + "static/media/grass.2e3c5d81b683495750259433f8ce1766.svg";
export { ForwardRef as ReactComponent };